/* global ga */
import React, { Component } from 'react';
import { observer } from 'mobx-react'
import AppBar from 'material-ui/AppBar';
import myFunctions from '../stores/myFunctions.js'
import FontAwesome from 'react-fontawesome'
import RaisedButton from 'material-ui/RaisedButton';
import NavStore from '../stores/NavStore';
import ActionHome from 'material-ui/svg-icons/action/home';
import _ from 'lodash'

const home = '/m/'

export default observer(class AppBarObject extends Component {

  home() {
    location.href = `${home}`
  }
  openNav = () => {
    NavStore.Toggle()
  }

  goReg() {
    ga('send', 'event', '門診時刻:頁面中按"掛號"');
    location.href = '/public/first_visit'
  }

  render() {
    let strUrl = location.search;
    let getPara, ParaVal;
    let aryPara = [];

    if (strUrl.indexOf("?") !== -1) {
      let getSearch = strUrl.split("?");
      getPara = getSearch[1].split("&");
      for (let i = 0; i < getPara.length; i++) {
        ParaVal = getPara[i].split("=");
        aryPara.push(ParaVal[0]);
        aryPara[ParaVal[0]] = ParaVal[1];
      }
    }

    return (
      <AppBar
        title={<span>門診時刻表<span style={{ fontSize: '10px' }}>{myFunctions.version}</span></span>}
        style={{ backgroundColor: '#3c91c6', textAlign: 'center', alignItems: 'center' }}
        titleStyle={{ color: "white", fontSize: '19px', fontWeight: 'bolder' }}
        //iconElementLeft={<IconButton>
        //<ActionHome onClick={() => { location.href = "/" }} />
        //</IconButton>}
        // iconClassNameRight="muidocs-icon-navigation-expand-more"
        iconElementLeft={
          <FontAwesome
            name='calendar'
            size='2x'
            style={{ color: '#fff', cursor: 'pointer' }}
            onClick={this.openNav}
          />
        }
        iconElementRight={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <RaisedButton
              label={'掛號'}
              labelColor="#FFFFFF"
              // backgroundColor="#7BC950"
              backgroundColor="#F15A24"
              labelStyle={{ fontSize: '20px' }}
              style={{ minWidth: '' }}
              // onTouchTap={(e) => { location.href = "/register" }}
              onTouchTap={this.goReg.bind(this)}
            />
            <div style={{ margin: '0px 5px' }}>
              <ActionHome onClick={this.home} />
            </div>
          </div>
        }
        className="bbbbbbbbbbb"
        id="ccccccccccc"
      />
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/AppBar.js